import { Autocomplete, TextField } from '@mui/material';
import { NetSuiteClass } from '@vy/types';
import { isEmptyString, isNullOrUndefined } from '@vy/utils';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useNetSuiteClasses } from '../../../../../../../hooks/requests/integrations';

type NetSuiteClassesDropdownProps<FormType extends FieldValues> = {
  fieldPath: FieldPath<FormType>;
  control: Control<FormType>;
  showDropdown?: boolean;
};

export function NetSuiteClassesDropdown<FormType extends FieldValues>({
  fieldPath,
  control,
  showDropdown = true,
}: NetSuiteClassesDropdownProps<FormType>) {
  const classes = useNetSuiteClasses(undefined, {
    enabled: showDropdown,
    suspense: false,
  });


  return (
    <Controller
      key={classes.length}
      control={control}
      name={fieldPath}
      render={({ field }) => {
        const currentClassValue = field.value;
        const matchingClass = findActiveClass(classes, currentClassValue);
        return (
          <Autocomplete
            disabled={!showDropdown}
            options={classes}
            getOptionLabel={(option) => option?.name ?? ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionKey={(option) => option?.id}
            value={matchingClass}
            onChange={(_, value) => {
              field.onChange(value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select NetSuite Class"
                onChange={(e) => {
                  if (isEmptyString(e.target.value)) {
                    field.onChange(null);
                  }
                }}
              />
            )}
          />
        );
      }}
    />
  );
}

function findActiveClass(classes: NetSuiteClass[], currentClassValue: NetSuiteClass | null) {
  if (isNullOrUndefined(currentClassValue)) {
    return null;
  }

  return classes.find((currentClass) => currentClass.id === currentClassValue.id);
}
